import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";


const WizardFormTemplate = () => {
  const [step, setStep] = useState(1);
  const [isDark, setIsDark] = useState(false);
  const [skin, setSkin] = useState("emerald");

const currentSkin =getCurrentSkin(skin)
  const { baseColor, baseShade } = currentSkin;

  const inputClass = `w-full px-4 py-2 rounded-lg text-sm border focus:outline-none focus:ring-2 ${
    isDark
      ? "bg-gray-800 text-white border-white/20 focus:ring-blue-400"
      : "bg-white text-black border-gray-300 focus:ring-blue-400"
  }`;

  const labelClass = `block mb-1 font-medium ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  const totalSteps = 4;

  return (
    <LayoutWrapper isDark={isDark} setIsDark={setIsDark} skin={skin} setSkin={setSkin}>
      <HeaderBar title="Vehicle Request Wizard" setSkin={setSkin} currentSkin={skin} />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border max-w-4xl mx-auto ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        {/* Progress Bar */}
        <div className="mb-6">
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
            <div
              className={`h-2.5 rounded-full transition-all duration-300 ease-in-out bg-${baseColor}-${baseShade}`}
              style={{ width: `${(step / totalSteps) * 100}%` }}
            />
          </div>
          <div className="flex justify-between text-xs mt-2 text-gray-500">
            <span>Step 1</span>
            <span>Step 2</span>
            <span>Step 3</span>
            <span>Step 4</span>
          </div>
        </div>

        {/* Form */}
        <form className="space-y-6">
          {step === 1 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Requisition No</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Date</label>
                <input type="date" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Branch</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Department</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Vehicle Code</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Vehicle Number</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Cumulative</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Head Material</label>
                <input type="text" className={inputClass} />
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>H.O.D</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Indent Reference</label>
                <input type="text" className={inputClass} />
              </div>
              <div>
                <label className={labelClass}>Approval Status</label>
                <select className={inputClass}>
                  <option value="">Select</option>
                  <option>Approved</option>
                  <option>Pending</option>
                  <option>Rejected</option>
                </select>
              </div>
            </div>
          )}

          {step === 4 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={labelClass}>Upload File</label>
                <input
                  type="file"
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
              </div>
              <div>
                <label className={labelClass}>Remarks</label>
                <textarea rows={4} className={inputClass} placeholder="Add remarks..." />
              </div>
            </div>
          )}

          {/* Navigation */}
          <div className="flex justify-between pt-6">
            <button
              type="button"
              disabled={step === 1}
              onClick={() => setStep((s) => Math.max(1, s - 1))}
              className={`px-5 py-2 rounded-lg text-sm font-medium ${
                step === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : `bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white`
              }`}
            >
              Back
            </button>

            {step < totalSteps ? (
              <button
                type="button"
                onClick={() => setStep((s) => Math.min(totalSteps, s + 1))}
                className={`px-6 py-2 text-white text-sm rounded-lg shadow bg-${baseColor}-${baseShade} hover:bg-${baseColor}-700`}
              >
                Next
              </button>
            ) : (
              <button
                type="submit"
                className={`px-6 py-2 text-white text-sm rounded-lg shadow bg-${baseColor}-${baseShade} hover:bg-${baseColor}-700`}
              >
                Submit Request
              </button>
            )}
          </div>
        </form>
      </div>
    </LayoutWrapper>
  );
};

export default WizardFormTemplate;
